import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useMaintenanceStore = defineStore(
    'store.maintenance',
    () => {
        const isMaintained = ref(false);

        const setMaintained = (value: boolean): void => {
            isMaintained.value = Boolean(value);
        };

        return { isMaintained, setMaintained };
    },
    {
        persist: true
    }
);
